import { useState } from 'react'
import { DateRange } from 'components/RangeDatePicker'
import ExportsActions from 'pages/Exports/components/ExportsActions'
import { useMutation } from '@apollo/client'
import { ExportResult, ExportVariables, ROOM_APPOINTMENTS_EXPORT } from 'graphql/exports/queries'
import { hasNoError } from 'globals/graphql'

interface IProps {
  onShowExportConfirmation: () => void
}

const RoomAppointments = (props: IProps) => {
  const { onShowExportConfirmation } = props
  const [dateRange, setDateRange] = useState<DateRange>()

  const [roomAppointmentExport] = useMutation<ExportResult, ExportVariables>(ROOM_APPOINTMENTS_EXPORT)

  const onExport = () =>
    dateRange && roomAppointmentExport({
      variables: {
        startingDate: dateRange.startDate.toISOString(),
        endingDate: dateRange.endDate.toISOString()
      }
    }).then(hasNoError(() => onShowExportConfirmation()))


  return (
    <div>
      <ExportsActions
        onExport={onExport}
        onDateRangeSelected={setDateRange}
      />
    </div>
  )
}

export default RoomAppointments
